import { render } from "./LibraryComponent.vue?vue&type=template&id=0f516b84&scoped=true"
import script from "./LibraryComponent.vue?vue&type=script&lang=js"
export * from "./LibraryComponent.vue?vue&type=script&lang=js"

import "./LibraryComponent.vue?vue&type=style&index=0&id=0f516b84&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0f516b84"]])

export default __exports__